import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {formatPhoneNumberUS, isObject, isSet, locations } from "../../utils/commonUtils";
import FormInputs from "../../components/UI/FormInputs";
import EmployeeService from "../../services/EmployeeService";
import withReduxState from "../../hoc/wReduxState";
import WithRoutify from "../../hoc/WithRoutify";
import Buttons from "../../components/UI/Buttons";
import { ItentificationTypeOptions, EthinicityOptions, genderOptions, raceOptions, RelationShipOptions,SOCIAL_SECURITY_NUMBER_FORMAT,isDotDriver } from "../../utils/constant";
import ClinicDepartmentService from "../../services/ClinicDepartmentService";
import InsuranceService from "../../services/InsuranceService";
import { useSelector } from "react-redux";
import { organizationList } from "../../store/OrganizationSlice";
import DropDownService from "../../services/DropDownService";
import OrganizationService from "../../services/OrganizationService";
import { FieldValidationFocus } from "../../utils/cssUtils";

// Canadian province codes to filter out (only show US states)
const canadianProvinces = ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];

// State options (US states only) - both label and value are state abbreviations
// Generated from locations object, excluding Canadian provinces
const stateOptions = [
  { label: "-Select State-", value: "" },
  ...Object.keys(locations)
    .filter(key => !canadianProvinces.includes(key))
    .map(key => ({
      label: key,
      value: key
    }))
];

const AddEmployee = (props) => {
  const { Toast } = props;
  const [validation, setValidation] = useState({});
  const [clinicLocationOptions, setClinicLocationOptions] = useState([]);
  const [formData, setFormData] = useState({});
  const { isOpen, modelTitle } = props;
  const organizationListOptions = useSelector(organizationList);
  const [companyOptions,setCompanyOption]=useState([]);
  const [clinicOptions,setClinicOptions]=useState([]);
  const [employeeOptions,setEmployeeOptions]=useState([]);
  const [insuranceListOptions, setInsuranceListOptions] = useState([]);
  const isMultipleOrg=props.profile.is_multiple_organization;
  const inputFields=getInputFields();
  useEffect(()=>{
    fetchCompaniesList();
    fetchInsuranceList();
    setFormData({...formData,clinic_name:'',clinic_id:'',clinic_department_id:'',...isSet(props.autoEmployeeFillData,{})});
    fetchEmployeeListOptions();
  },[formData.organization]);


  useEffect(()=>{
      fetchCompanyDetails(formData.company_id);
  },[formData.company_id]);
  // useEffect(()=>{
  // },[companyOptions,clinicLocationOptions])
useEffect(()=>{
  if (formData.clinic_id) {
    fetchClinicLocationList(formData.clinic_id)
  }
},[formData.clinic_id]);
 const fetchCompaniesList = async () => {
  let companiesOptions = [{ label: "-Select Company-", value: "" }];
  let response=[];
  if (isMultipleOrg) {
    response=await DropDownService.getCompanies(formData.organization); 
  }
  else{
    response=await DropDownService.getCompanies(null);
  }
  response&&isSet(response, []).forEach((company) => {
    companiesOptions.push({
      label: company.name,
      value: company.company_uuid,
    });
  });
  setCompanyOption(companiesOptions);
  };
  const changeHandler = async (val, fieldName,dependencyValues = {}) => {
    let updateFormData={...formData};
    const updateValidation={...validation};
    if (fieldName === "address") {
      const {addressParam}=dependencyValues;
      if (addressParam) {
        // Extract house number from full address using regex (matches digits at the start)
        let houseNumber = "";
        const fullAddress = val || "";
        const trimmedAddress = fullAddress.trim();
        const houseNumberMatch = trimmedAddress.match(/^\d+/);
        if (houseNumberMatch) {
          houseNumber = houseNumberMatch[0];
        }
        
        // Combine house number with street name
        const streetName = addressParam.street || "";
        const streetAddress = houseNumber ? `${houseNumber} ${streetName}`.trim() : streetName;
        
        updateFormData = {
              ...updateFormData,
              street_address: streetAddress,
              city: addressParam.city || "",
              state: addressParam.state || "",
              country: addressParam.country || "",
              zip_code: addressParam.zipcode || ""
          };
      }
  }
  if ((fieldName === 'dependent_id')) {
    const { phone, address,city,street_address, zip_code, state,employee_id,company_id,clinic_id} = await getDependentDetails(fieldName === 'dependent_id' ? val : '');    
    updateFormData['phone'] = phone;

    updateFormData['street_address'] = street_address;
    updateFormData['zip_code'] = zip_code;
    updateFormData['state'] = state;
    updateFormData['address']=address;
    updateFormData['city']=city;

    // updateFormData['employee_id'] = employee_id;
    updateFormData['company_id']=company_id;
    updateFormData['clinic_id']=clinic_id;
  }
  if (fieldName=='is_dependent') {
    if (val==0) {
      updateFormData['dependent_id']='';
    }
  }
  // 1. If "Is DOT Driver" changes
if (fieldName === 'is_dot_driver') {
  if (val == 1) {
    updateFormData['identification_type'] = "Driver's License";
  } else {
    updateFormData['identification_type'] = ""; // Resets to "-Select-"
  }
}

// 2. If "Identification Type" changes
if (fieldName === 'identification_type') {
  if (val === "Driver's License") {
    // If user manually selects Driver's License, we can leave DOT driver as is
    // or set it to 1 if that is your preferred default.
    if (updateFormData.identification_number) {
      updateFormData['driver_license'] = updateFormData.identification_number;
      updateFormData['is_dot_driver'] = 1; // Set DOT Driver to Yes if ID number exists
    }
  } else {
    // FIX: If type is NOT Driver's License, force DOT Driver to 0 (No)
    updateFormData['is_dot_driver'] = 0;
    updateFormData['driver_license'] = '';
    updateFormData['license_issuing_state'] = '';
  }
  }
  if (fieldName=='identification_number') {   
    if (updateFormData.identification_type=="Driver's License") { //identification_number update for driver license
      updateFormData['driver_license']=val;
    }
  }

  if(fieldName === 'identification_type' && val === "Driver's License" && updateFormData.identification_number !=''){
    updateFormData['driver_license'] = updateFormData.identification_number;
  }else if(fieldName === 'identification_type' && val !== "Driver's License"){
    if(updateFormData.identification_number !=''){
      updateFormData['driver_license'] = '';
    }
    // Clear license_issuing_state when identification type is not Driver's License
    updateFormData['license_issuing_state'] = '';
  }
    updateValidation[fieldName]='';
    updateFormData[fieldName]=val;
    setFormData(updateFormData);
    setValidation(updateValidation);
  };
  const fetchCompanyDetails = async (companyId) => {
    try {
      // let updateFormData={...formData};
      let updateValidation={...validation};
      if (companyId) {

        const data = await DropDownService.getClinicDropDownListByCompany(isSet(formData.organization,null),{company_id:companyId});
        console.log('assigned_cinics',data);
        let options=[{label:'-Select Clinic',value:''}];
        data.forEach(item => {
          options.push({label:item.name,value:item.clinic_id})
        });
        setClinicOptions(options);
      }
      // else{
      //   updateFormData['clinic_name']='';
      //   updateFormData['clinic_id']='';
      //   let clinicLocationInArr = [{ label: '-None-', value: '' }];
      //   setClinicLocationOptions(clinicLocationInArr);
      // }  
      // setFormData(updateFormData);
      setValidation(updateValidation);
       
    } catch (e) {

    }
  }
  const fetchClinicLocationList = async (clinicId) => {
    try {
      const data = await ClinicDepartmentService.getClinicDepartmentByClinicId(isSet(formData.organization,null),clinicId);
      let clinicLocationInArr = [{ label: '-Select-', value: '' }];
      isSet(data, []).forEach((item, itemIndex) => {
        clinicLocationInArr.push({
          label: item.facility_name,
          value: item.id,
          key: itemIndex
        })
      });
      setClinicLocationOptions(clinicLocationInArr);
    } catch (e) {

    }
  }
  const fetchEmployeeListOptions=async()=>{
    const response =await DropDownService.getEmployeeList(isSet(formData.organization,null));
    let options=[{label:'-Select-',value:''}]
    response&&response?.forEach((itm,index)=>{
      options.push({label:`${itm.first_name} ${itm.last_name} - ${formatPhoneNumberUS(itm.phone)}`,value:itm.employee_id});
    });
    setEmployeeOptions(options);    
  }
  const fetchInsuranceList = async () => {
    let options = [{ label: '-Select-', value: '' }];
    try {
      const res = await InsuranceService.getInsurance();
      const resData = res?.data;
      const list = (resData?.data?.data || []);
      (Array.isArray(list) ? list : []).forEach((item) => {
        options.push({ label: item.insurance_name, value: item.insurance_company_id });
      });
      setInsuranceListOptions(options);
    } catch (e) {}
  };
  const getDependentDetails=async(employee_id='')=>{
    props.Loader(true);
    const employeeDetails=await EmployeeService.getEmployee(employee_id);
    props.Loader(false);
    return {
      phone:employeeDetails.phone ||'',

      address:employeeDetails.address ||'',
      street_address:employeeDetails.street_address ||'',
      state:employeeDetails.state ||'',
      city:employeeDetails.city || '',
      zip_code:employeeDetails.zip_code ||'',

      company_id:employeeDetails.company_id,
      clinic_id:employeeDetails.clinic_id,
      employee_id:employee_id,
    }
  }

  const formSubmitHandler = async () => {
    const { Loader } = props;
    let updateValidation = {};
    //check if global admin 
    if (isSet(props.profile.is_multiple_organization, false) === true && organizationListOptions.length > 2) {
      //check organization filled if no throwing validation
      if (isSet(formData.organization, false) == false) {
        setValidation({
          ...updateValidation,
          ['organization']: 'The Organization Field is Required',
        });
        return false
      }
    }
    const payload = {
      ...formData
    }
    const formDataPayload = new FormData();
    for (const i in payload) {
      formDataPayload.append(i, payload[i]);
    }
    
    // return false;
    const headers = {
      'Content-Type': 'multipart/form-data'
    };
    try {
      Loader(true);
      const data = await EmployeeService.saveEmployee(isSet(formData.organization, null), formDataPayload, headers);
      console.log('saved emplyoleee dataaa-->',data);
      Loader(false);
      // console.log('data',data);
      if (data.status && data.status === "ERROR") {
        if (isObject(data.data)) {
          // Keys from validateEmployeData that should show toast notifications
          const toastKeys = ['dependent_id', 'phone', 'email','social_security_number'];
          
          // Collect error messages for toast notifications (only for specific keys)
          const errorMessages = [];
          for (let key in data.data) {
            const fieldErrors = Array.isArray(data.data[key]) ? data.data[key] : [data.data[key]];
            
            // Only collect toast messages for specific keys
            if (toastKeys.includes(key)) {
              fieldErrors.forEach(errorMsg => {
                errorMessages.push(errorMsg);
              });
            }
            
            updateValidation = {
              ...updateValidation,
              [key]: fieldErrors.join(","),
            };
          }
          // Show validation errors as toast notifications (only for specific keys)
          if (errorMessages.length > 0) {
            errorMessages.forEach(msg => {
              props.Toast.error(msg);
            });
          }
        } else {
          props.Toast.error(data.data);
        }
        if (Object.keys(updateValidation).length > 0) {
          setValidation(updateValidation);
          FieldValidationFocus(inputFields, updateValidation); 
        }
      } else {
        props.fetchEmployeeList();
        props.modalToogleHandler(false, 'ADD_VISIT', {
          ...data,
          visit_date:props.autoFillData?.visit_date,
          visit_time:props.autoFillData?.visit_time});
        Toast.success('Employee Added Successfully');
      }
    } catch (e) {
      Loader(false);

    }
  }
  // console.log('formData',formData);
  return (
    <>
      <Modal
        show={isOpen}
        onHide={() => {
          props.modalToogleHandler(false);
          if (props.clearAutoEmployeeFillData) {
            props.clearAutoEmployeeFillData(); 
          }
        }}
        size='xl'
        dialogClassName='hResponsive'
        contentClassName='h-100'
        backdrop="static"
        keyboard={false}
      >
        <div className="sh_modalBox">
          <Modal.Header closeButton>
            <Modal.Title>
              <h6 className="text-lg mb-0 font-weight-bold">
                {modelTitle}
              </h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="card-body tab-content p-0">
              {inputFields &&
                inputFields.map((section, sectionIndex) => {
                  return (
                    <>
                      <div className="card mb-2">
                        <a
                          href={`#collapseCardExample_${sectionIndex}`}
                          className="d-block sh_accordionheader card-header"
                          data-bs-toggle="collapse"
                          role="button"
                          aria-expanded="true"
                          aria-controls="collapseCardExample"
                          style={{
                            position: "sticky",
                            top: "-15px",
                            zIndex: "1",
                          }}
                        >
                          <h6 className="m-0 text-md">
                            {section.title}
                          </h6>
                        </a>
                        <div
                          className="collapse show"
                          id={`collapseCardExample_${sectionIndex}`}
                          data-bs-parent="#modal111"
                        >
                          <div className="card-body">
                            <div className="row">
                              {section.data.map((field, fieldIndex) => {
                                const col = isSet(field.col, 'col-lg-4 col-6');
                                if (isSet(field.isShow, true) === false) { return false }
                                return (
                                  <div className={`${col} `} key={fieldIndex}>
                                    <div className={`form-group ${isSet(field.isLabelAppend, false) === true ? 'form-check form-check-solid' : ''}`} >
                                      {(isSet(field.isLabelAppend, false) === false) ?
                                        <label className="mb-0 text-sm opacity-75 text-truncate">
                                          {field.label}
                                        </label>
                                        : <></>}

                                      <FormInputs {...field} id={isSet(field.id,field.name)} value={formData[field.name]} changeHandler={(value, e) => changeHandler(value, field.name, e)} />
                                      {(isSet(field.isLabelAppend, false) === true) ?
                                        <label className="form-check-label" htmlFor={field.name}>
                                          {field.label}
                                        </label>
                                        : <></>}
                                      {isSet(field.isNotValidate) ? <></>
                                        : ((isSet(validation[field.name], "") !== "" && !formData[field.name]) ? (
                                          <span className="text-danger m-1">
                                            {isSet(validation[field.name], "")}
                                          </span>
                                        ) : (
                                          ""
                                        ))}
                                    </div>
                                  </div>
                                )

                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-center">
            <Buttons
              type='Single'
              className="btn btn-primary"
              clickHandler={() => formSubmitHandler()}
              label='Save'
              acl={'any'} />
            {/* <Buttons
              clickHandler={() => addFormHandler()}
              className="btn btn-outline-secondary rounded-pill"
              acl={"any"}
              label={"Cancel"}
            />
            */}
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
  function getInputFields(){
    const inputFields = [
      {
        title: 'Company and Clinic Details',
        data: [
          {
            type: "SelectList",
            label: "Company",
            placeholder: "Company",
            className: "form-control form-control-solid",
            name: "company_id",
            options: companyOptions,
            value: formData.company_id,
            required: true,
          },
          {
            type: "SelectList",
            options:clinicOptions,
            label: "Clinic",
            placeholder: "Clinic",
            className: "form-control form-control-solid",
            name: "clinic_id",
            value: formData.clinic_id,
            required: true,
          },
          {
            type: "SelectList",
            label: "Clinic Department",
            placeholder: "Clinic Department",
            className: "form-control form-control-solid",
            name: "clinic_department_id",
            options: clinicLocationOptions,
            readOnly: isSet(formData.company_id, null) === null ? true : false,
            value: formData.clinic_department_id,
          },
        ]
      },
      {
        title: 'Personal',
        data: [
          {
            type: "Checkbox",
            label: "Is Dependent ?",
            placeholder: "",
            isLabelAppend: true,
            className: "form-check-input",
            id: 'is_dependent',
            name: "is_dependent",
            value: formData.is_dependent,
          },
           {
            type: "SelectList",
            options:employeeOptions,
            label: "Patient/Employee",
            placeholder: "Patient/Employee",
            className: "form-control form-control-solid",
            name: "dependent_id",
            value: formData.dependent_id,
            required: true,
            isShow:formData.is_dependent==1,
          },
          {
            type: "SelectList",
            options:RelationShipOptions,
            label: "Dependent Relationship",
            placeholder: "Last Name",
            className: "form-control form-control-solid",
            name: "dependent_relationship",
            value: formData.dependent_relationship,
            isShow:formData.is_dependent==1,
          },
          {
            type: "TextInput",
            label: "First Name",
            placeholder: "First Name",
            className: "form-control form-control-solid",
            name: "first_name",
            isFirstLetterCaps:true,
            value: formData.first_name,
            required: true,
          },
          {
            type: "TextInput",
            label: "Last Name",
            placeholder: "Last Name",
            className: "form-control form-control-solid",
            name: "last_name",
            value: formData.last_name,
            isFirstLetterCaps:true,
            required: true,
          },
          {
            type: "SelectList",
            label: "Gender",
            placeholder: "Gender",
            className: "form-control form-control-solid",
            name: "gender",
            options: genderOptions,
            value: formData.gender,
            required:true
          },
          {
            type: "Date",
            label: "Date of Birth",
            placeholder: "Date of Birth",
            className: "form-control form-control-solid",
            name: "dob",
            value: formData.dob,
            required: true,
            disableFuture:true
          },
          {
            type: "Age",
            label: "Age",
            placeholder: "",
            readOnly: true,
            className: "form-control form-control-solid",
            name: "dob",
            value: formData.dob,
            required: true,
            isNotValidate:true
          },
          {
            type: "Phone",
            label: "Social Security Number",
            placeholder: "Social Security Number",
            className: "form-control form-control-solid",
            name: "social_security_number",
            value: formData.social_security_number,
            numberFormat: SOCIAL_SECURITY_NUMBER_FORMAT,
            maskChar: 'x',
          },
          {
            type: "SelectList",
            label: "Ethnicity",
            placeholder: "Ethnicity",
            className: "form-control form-control-solid",
            name: "ethnicity",
            options: EthinicityOptions,
            value: formData.ethnicity,
          },
          {
            type: "SelectSearchList",
            label: "Race",
            placeholder: "Race",
            options: raceOptions,
            className: "form-control form-control-solid",
            name: "race",
            value: formData.race,
            isMulti: true,
          },
        ]
      },
      {
        title: 'Address',
        data: [
          {
            type: "TextInput",
            label: "Street",
            placeholder: "street",
            className: "form-control form-control-solid",
            name: "street_address",
            value: formData.street_address,
            required: true,
          },
          {
            type: "TextInput",
            label: "City",
            placeholder: "City",
            className: "form-control form-control-solid",
            name: "city",
            value: formData.city,
            required: true,
          },
          {
            type: "TextInput",
            label: "State",
            placeholder: "State",
            className: "form-control form-control-solid",
            name: "state",
            value: formData.state,
            required: true,
          },
          {
            type: "TextInput",
            label: "County",
            placeholder: "County",
            className: "form-control form-control-solid",
            name: "county",
            value: formData.county,
          },
          {
            type: "ZipCode",
            label: "Zipcode",
            placeholder: "Zipcode",
            className: "form-control form-control-solid",
            name: "zip_code",
            value: formData.zip_code,
            required: true,
          },
        ]
      },
      {
        title: 'Contact',
        data: [
          {
            type: "TextInput",
            label: "Email",
            placeholder: "Email",
            className: "form-control form-control-solid",
            name: "email",
            value: formData.email,
            required: formData.is_online_portal == 1 ? true : false,
          },
          {
            type: "Phone",
            label: "Cell Number",
            placeholder: "Cell Number",
            className: "form-control form-control-solid",
            name: "phone",
            value: formData.phone,
            required: true,
          },
        ]
      },
      {
        title: 'Identification',
        data: [
          {
            type: "SelectList",
            label: "Is Dot Driver?",
            placeholder: "IS Dot Driver?",
            className: "form-control form-control-solid",
            name: "is_dot_driver",
            value: formData.is_dot_driver,
            options: isDotDriver,
          },
          {
            type: "SelectList",
            label: "Identification type",
            placeholder: "Identification type",
            className: "form-control form-control-solid",
            name: "identification_type",
            options: ItentificationTypeOptions,
            value: formData.identification_type,
            required: true,
          },
          {
            type: "TextInput",
            label: "Identification number",
            placeholder: "Identification number",
            className: "form-control form-control-solid",
            name: "identification_number",
            value: formData.identification_number,
            required:true,
          },
          {
            type: "SelectList",
            label: "License Issuing State",
            placeholder: "License Issuing State",
            className: "form-control form-control-solid",
            name: "license_issuing_state",
            options: stateOptions,
            value: formData.license_issuing_state,
            required: formData.identification_type === "Driver's License",
            isShow: formData.identification_type === "Driver's License",
          },
          {
            type: "FileUpload",
            label: "ID Picture",
            placeholder: "",
            className: "form-control form-control-solid",
            id: 'id_picture',
            name: "id_picture",
            value: formData.id_picture,
          },
        ]
      },
      {
        title: 'Private Insurance',
        data: [
          {
            type: "SelectList",
            label: "Insurance Name",
            placeholder: "Insurance Name",
            className: "form-control form-control-solid",
            name: "insurance_id",
            options: insuranceListOptions,
            value: formData.insurance_id,
          },
          {
            type: "TextInput",
            label: "Member Number",
            placeholder: "Member Name",
            className: "form-control form-control-solid",
            name: "member_number",
            value: formData.member_number,
          },
          {
            type: "TextInput",
            label: "Group Number",
            placeholder: "Group Number",
            className: "form-control form-control-solid",
            name: "group_number",
            value: formData.group_number,
          },
          {
            type: "FileUpload",
            label: "Insurance Card (Front)",
            placeholder: "",
            className: "form-control form-control-solid",
            id: 'insurance_card_front',
            name: "insurance_card_front",
            value: formData.insurance_card_front,
          },
          {
            type: "FileUpload",
            label: "Insurance Card (Back)",
            placeholder: "",
            className: "form-control form-control-solid",
            id: 'insurance_card_back',
            name: "insurance_card_back",
            value: formData.insurance_card_back,
          },
        ]
      },
      {
        title: 'Employer',
        data: [
          {
            type: "TextInput",
            label: "Job Title Description",
            placeholder: "Job Title Description",
            className: "form-control form-control-solid",
            name: "job_title_description",
            value: formData.job_title_description,
          },
          {
            type: "Date",
            label: "Start Date",
            name: "start_date",
            className: "form-control form-control-solid",
            value: formData.start_date,
            placeholder: "Start Date",
            required: false,
          },
          {
            type: "TextInput",
            label: "Employee Relationship",
            placeholder: "Employee Relationship",
            className: "form-control form-control-solid",
            name: "employee_relationship",
            value: formData.employee_relationship,
          },
          {
            type: "TextInput",
            label: "Reporting Supervisor",
            placeholder: "Reporting Supervisor",
            className: "form-control form-control-solid",
            name: "reporting_supervisor",
            isFirstLetterCaps: true,
            value: formData.reporting_supervisor,
          },
          {
            label: " Benefit Type",
            type: "TextInput",
            name: "benefit_type",
            className: "form-control form-control-solid",
            value: formData.benefit_type,
            placeholder: "Benefit Type",
          },
          {
            type: "TextInput",
            label: "License/Certification Description",
            name: "license_certification_description",
            className: "form-control form-control-solid",
            value: formData.license_certification_description,
            placeholder: "License/Certification Description",
          },
          {
            type: "Date",
            label: "License Effective Date",
            name: "license_effective_date",
            className: "form-control form-control-solid",
            value: formData.license_effective_date,
            placeholder: "License Effective Date",
          },
          {
            type: "Date",
            label: "License Expiration Date",
            name: "license_expiration_date",
            className: "form-control form-control-solid",
            value: formData.license_expiration_date,
            placeholder: "License Expiration Date",
          },
          {
            type: "Checkbox",
            label: "Disable Labs / Drug Screen Notification",
            placeholder: "",
            isLabelAppend: true,
            className: "form-check-input",
            id: 'disable_labs_drugscreen_notification',
            name: "disable_labs_drugscreen_notification",
            value: formData.disable_labs_drugscreen_notification,
          },
        ]
      },
      {
        title: 'Additional Information',
        data: [
          {
            type: "Checkbox",
            label: "Create Online Access for Patients ?",
            placeholder: "",
            isLabelAppend: true,
            className: "form-check-input",
            id: 'is_online_portal',
            name: "is_online_portal",
            value: formData.is_online_portal,
          },
          {
            type: "Checkbox",
            label: "Preferred Language: Spanish",
            placeholder: "",
            isLabelAppend: true,
            className: "form-check-input",
            id: 'is_spanish_preferred_language',
            name: "is_spanish_preferred_language",
            value: formData.is_spanish_preferred_language,
          },
          {
            type: "TextInput",
            label: "Full Name of Guardian & Parents",
            placeholder: "Full Name of Guardian & Parents",
            className: "form-control form-control-solid",
            name: "guardian_name",
            value: formData.guardian_name,
          },
          {
            type: "Phone",
            label: "Guardian Cell Number",
            placeholder: "Guardian Cell Number",
            className: "form-control form-control-solid",
            name: "guardian_phone",
            value: formData.guardian_phone,
          },
          {
            type: "TextInput",
            label: "Patient Id",
            placeholder: "Patient Id",
            className: "form-control form-control-solid",
            name: "patient_id",
            value: formData.patient_id,
          },
          {
            type: "TextInput",
            label: "Booking Id",
            placeholder: "Booking Id",
            className: "form-control form-control-solid",
            name: "booking_id",
            value: formData.booking_id,
          },
        ]
      }
    ];
    if (isSet(props.profile.is_multiple_organization, false) === true) {
      inputFields[0].data.unshift(
        {
          type: "SelectList",
          label: "Organization",
          options:organizationListOptions,
          placeholder: "",
          className: "form-control form-control-solid",
          name: "organization",
          value: isSet(formData.organization,OrganizationService.getOrgId()),
          required:true
        }
      );
    }
    return inputFields;
  }
};

AddEmployee.defaultProps = {
  autoFillData:{visit_date:'',visit_time:''},
  autoEmployeeFillData:{}
}
export default withReduxState(WithRoutify(AddEmployee));